import React from 'react';
import chameleonImage from '../assets/transly-chameleon.png';

export default function TranslyChameleon({ size = 200, className = '' }) {
  return (
    <img
      src={chameleonImage}
      alt="Transly"
      width={size * 1.4}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}
